// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/exchanger/exchanger.proto" (package "mlmbox.client.exchanger", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Exchanger as Exchanger$ } from "./exchanger.ts";
import type { Exchanger_Response } from "../../types/exchanger.ts";
import type { Exchanger_Request } from "../../types/exchanger.ts";
import type { Exchanger_List } from "../../types/exchanger.ts";
import type { Empty } from "../../../google/protobuf/empty.ts";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { Exchanger } from "../../types/exchanger.ts";
import type { Exchanger_Id } from "../../types/exchanger.ts";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service mlmbox.client.exchanger.Exchanger
 */
export interface IExchangerClient {
    /**
     * @generated from protobuf rpc: Get(mlmbox.types.Exchanger.Id) returns (mlmbox.types.Exchanger);
     */
    get(input: Exchanger_Id, options?: RpcOptions): UnaryCall<Exchanger_Id, Exchanger>;
    /**
     * @generated from protobuf rpc: All(google.protobuf.Empty) returns (mlmbox.types.Exchanger.List);
     */
    all(input: Empty, options?: RpcOptions): UnaryCall<Empty, Exchanger_List>;
    /**
     * @generated from protobuf rpc: Preview(mlmbox.types.Exchanger.Request) returns (mlmbox.types.Exchanger.Response);
     */
    preview(input: Exchanger_Request, options?: RpcOptions): UnaryCall<Exchanger_Request, Exchanger_Response>;
    /**
     * @generated from protobuf rpc: Verified(mlmbox.types.Exchanger.Request) returns (mlmbox.types.Exchanger.Response);
     */
    verified(input: Exchanger_Request, options?: RpcOptions): UnaryCall<Exchanger_Request, Exchanger_Response>;
}
/**
 * @generated from protobuf service mlmbox.client.exchanger.Exchanger
 */
export class ExchangerClient implements IExchangerClient, ServiceInfo {
    typeName = Exchanger$.typeName;
    methods = Exchanger$.methods;
    options = Exchanger$.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Get(mlmbox.types.Exchanger.Id) returns (mlmbox.types.Exchanger);
     */
    get(input: Exchanger_Id, options?: RpcOptions): UnaryCall<Exchanger_Id, Exchanger> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<Exchanger_Id, Exchanger>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: All(google.protobuf.Empty) returns (mlmbox.types.Exchanger.List);
     */
    all(input: Empty, options?: RpcOptions): UnaryCall<Empty, Exchanger_List> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, Exchanger_List>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Preview(mlmbox.types.Exchanger.Request) returns (mlmbox.types.Exchanger.Response);
     */
    preview(input: Exchanger_Request, options?: RpcOptions): UnaryCall<Exchanger_Request, Exchanger_Response> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<Exchanger_Request, Exchanger_Response>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Verified(mlmbox.types.Exchanger.Request) returns (mlmbox.types.Exchanger.Response);
     */
    verified(input: Exchanger_Request, options?: RpcOptions): UnaryCall<Exchanger_Request, Exchanger_Response> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<Exchanger_Request, Exchanger_Response>("unary", this._transport, method, opt, input);
    }
}
